import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VuexPersistence from 'vuex-persist'
import modules from './modules'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    gestion: gestion.state.infoContacto,
  })
})

export default new Vuex.Store({
  modules,
  state: {
    loading: false,
    api: axios.create({baseURL: process.env.VUE_APP_API}),
    uuid: "",
    ownerid:"",
    ownertype:"",
    sub_tipo_gestion_name:"",
    telefono:null,
    agent_id:"",
    codigo_tipo_gestion:"",
  },
  getters: {
    api: state => state.api,
    loading: state => state.loading,
    inicioGestion: state => state.inicioGestion,
    uuid:state => state.uuid,
    telefono:state => state.telefono,
    ownerid:state => state.ownerid,
    ownerType:state => state.ownertype,
    sub_tipo_gestion_name: state => state.sub_tipo_gestion_name,
    agent_id: state => state.agent_id,
    codigo_tipo_gestion: state => state.codigo_tipo_gestion
  },
  mutations: {
    SET_LOADING: (state, payload) => state.loading = payload,
    SET_INICIO_GESTION: (state, payload) => state.inicioGestion = payload,
    SET_UUID: (state, payload) => state.uuid = payload,
    SET_TELEFONO: (state, payload) => state.telefono = payload,
    SET_OWNERID: (state, payload) => state.ownerid = payload,
    SET_OWNERTYPE: (state, payload) => state.ownertype = payload,
    SET_SUB_TIPO_GESTION_NAME: (state, payload) => state.sub_tipo_gestion_name = payload,
    SET_AGENT_ID: (state, payload) => state.agent_id = payload,
    SET_CODIGO_TIPO_GESTION: (state, payload) => state.codigo_tipo_gestion = payload,
    CLEAR_UUID:(state) => state.uuid = "",
    CLEAR_TELEFONO:(state) => state.telefono = null,
    CLEAR_AGENT_ID:(state) => state.agent_id = "",
  },
  actions: {
    index({state, commit}, payload) {
      commit('SET_LOADING', true)
      return new Promise((res,rej) => {
          state.api.get(payload.endpoint, {params: payload.params?payload.params:{}})
          .then((response) => {
            res(response.data)
          })
          .catch((error) => {
            rej(error)
          })
          .then(() => {
            commit('SET_LOADING', false)
          })
      });
    },
    store({state, commit}, payload) {
      commit('SET_LOADING', true)
      return new Promise((res, rej) => {
        state.api.post(payload.endpoint, payload.params?payload.params:{}, payload.config ? payload.config : {})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error.response)
        })
        .then(() => {
          commit('SET_LOADING', false)
        })
      })
    },
    show({state, commit}, payload) {
      commit('SET_LOADING', true)
      return new Promise((res, rej) => {
        state.api.post(payload.endpoint+'/'+payload.id)
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error.response)
        })
        .then(() => {
          commit('SET_LOADING', false)
        })
      })
    },
    edit({state, commit}, payload) {
      commit('SET_LOADING', true)
      return new Promise((res, rej) => {
        state.api.put(payload.endpoint, payload.params?payload.params:{})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error.response)
        })
        .then(() => {
          commit('SET_LOADING', false)
        })
      })
    },
    remove({state, commit}, payload) {
      commit('SET_LOADING', true)
      return new Promise((res, rej) => {
        state.api.delete(payload.endpoint, payload.params?payload.params:{})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error.response)
        })
        .then(() => {
          commit('SET_LOADING', false)
        })
      });
    }
  }
})